import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormControl, Select, MenuItem } from '@mui/material';

const LanguageSelector = ({ size = 'small', variant = 'outlined', sx }) => {
  const { i18n, t } = useTranslation();

  const handleChange = React.useCallback((event) => {
    const nextLanguage = event.target.value;

    if (nextLanguage === i18n.language) {
      return;
    }

    i18n.changeLanguage(nextLanguage);
  }, [i18n]);

  return (
    <FormControl size={size} variant={variant} sx={sx}>
      <Select
        value={i18n.language || 'fr'}
        onChange={handleChange}
        renderValue={(value) => {
          if (i18n.language === 'ar') {
            // For Arabic, show 3rd and 4th letters of the language name
            const languageName = t(`language.${value}`);
            return languageName.substring(2, 4);
          }
          // For French and English, show standard abbreviations
          if (value === 'fr') return 'FR';
          if (value === 'en') return 'EN';
          if (value === 'ar') return 'AR';
          return String(value).toUpperCase();
        }}
      >
        <MenuItem value="fr">{t('language.fr')}</MenuItem>
        <MenuItem value="en">{t('language.en')}</MenuItem>
        <MenuItem value="ar">{t('language.ar')}</MenuItem>
      </Select>
    </FormControl>
  );
};

export default LanguageSelector;
